module.exports = __webpack_public_path__ + "assets/svg/Icons/32/document-yellow-4f9076.svg";